import React from 'react';

import UniqueControlList from './UniqueControlList';
import MultipleControlList from './MultipleControlList';

export const List = ({ multiple, ...props }) => (
  multiple
    ? <MultipleControlList {...props} />
    : <UniqueControlList {...props} />
);

export default List;



// WEBPACK FOOTER //
// ./src/components/Form/FormActivity/Controls/ControlList/index.js